import { render, staticRenderFns } from "./AcompanhamentoSetor.vue?vue&type=template&id=6c715ac2"
import script from "./AcompanhamentoSetor.vue?vue&type=script&lang=js"
export * from "./AcompanhamentoSetor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports